module.exports = __webpack_public_path__ + "img/大事记logo1.5be9c0e6.png";